export const TEMPERATURAOGRANICENA_V1ResourcesDE: TEMPERATURAOGRANICENA_V1ResourcesBSInterface =
  {
    labelDone: "Datum der Aufgabenerledigung",
    errorMissingInput: "Bitte füllen Sie alle Felder aus",
    input: {
      signatureTitle: "Unterschrift",
      checkbox: {
        label:
          "Ich bestätige, dass ich darüber informiert wurde, dass die Temperatur nicht angemessen ist",
        name: "checkbox",
        placeholder: "Sie müssen dieses Feld akzeptieren",
      },
      datum: {
        label: "Bitte geben Sie das Datum ein",
        placeholder: "Bitte geben Sie das Datum ein",
        name: "datum",
      },
      ocitanaTemperatura: {
        label: "Abgelesene Temperatur",
        name: "ocitanaTemperatura",
        placeholder: "Bitte geben Sie die abgelesene Temperatur ein",
      },
      napomena: {
        label: "Notiz",
        name: "napomena",
        placeholder: "Bitte geben Sie eine Notiz ein",
      },
    },
    evidencijaForm: {
      buttonForward: "Unterschreiben",
      buttonBack: "Zurück",
    },
    successModal: {
      title: "Dateneingabe",
      body: "Das Hinzufügen von Daten wurde erfolgreich abgeschlossen. Wählen Sie OK zum Fortfahren.",
      buttonOk: "OK",
    },
    txtPotvrda:
      "Durch die Auswahl der Option Unterschreiben bestätige ich, dass die Aufgabe gemäß den Anweisungen ausgeführt wurde!",
  };

interface InputField {
  label: string;
  name: string;
  placeholder?: string;
}

interface Input {
  signatureTitle: string;
  datum: InputField;
  ocitanaTemperatura: InputField;
  napomena: InputField;
  checkbox: InputField;
}

interface EvidencijaForm {
  buttonForward: string;
  buttonBack: string;
}

interface SuccessModal {
  title: string;
  body: string;
  buttonOk: string;
}

export interface TEMPERATURAOGRANICENA_V1ResourcesBSInterface {
  labelDone: string;
  errorMissingInput: string;
  input: Input;
  evidencijaForm: EvidencijaForm;
  successModal: SuccessModal;
  txtPotvrda: string;
}
